package com.havn.app.features.auth.data

actual object HavnAuthSignInPolicy {
    actual val emailOtpCreatesUsers: Boolean = true
}
